<template>
  <div id="app">
    <div id="main-wrapper" class="main-wrapper">

      <HeaderOne />

      <PhotoShow /> 

      <Introduction />  

      <Member2 />

      <Shows />

      <SongList2 />

      <Invitation2 />

      <Support />

      <About /> 

      <FooterTwo />

    </div>
  </div>
</template>

<script>

export default {
  name: "App",

  components: {
    HeaderOne: () => import("@/components/hkcco/HeaderOne"),
    VideoFront:() => import("@/components/hkcco/VideoFront"),
    Banner: () => import("@/components/hkcco/Banner"),
    Introduction: () => import("@/components/hkcco/Introduction"),    
    Member2: () => import("@/components/hkcco/Member2"),
    Shows:() => import("@/components/hkcco/CardGrid"),
    SongList2:() => import("@/components/hkcco/SongList2"),
    Invitation2:() => import("@/components/hkcco/Invitation2"),
    Support:() => import("@/components/hkcco/Support"),
    About: () => import("@/components/hkcco/About"),
    PhotoShow:() => import("@/components/hkcco/PhotoShow"),
    FooterTwo: () => import("@/components/hkcco/FooterTwo"),
  },
    
}; 
</script>
